import React from 'react'
import PropTypes from 'prop-types'
import api from 'services/pet-notify-api'
import InvitationPetParentEmailAcceptedScreen from 'ContactApp/screens/Invitation-Pet-Parent-Email/Accepted'

class InvitationAcceptedScreenContainer extends React.PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        token: PropTypes.string,
      }),
    }),
  }

  state = {
    isLoading: true,
    error: '',
  }

  async componentDidMount() {
    const { match } = this.props
    const { params } = match
    const { token } = params

    try {
      const petParent = await api.petParentInvitations.view(token)
      this.setState({ isLoading: false, petParent, type: 'email' })
    } catch (error) {
      this.setState({ isLoading: false, error })
    }
  }

  generateProps = () => ({
    ...this.props,
    ...this.state,
  })

  render() {
    const props = this.generateProps()

    return <InvitationPetParentEmailAcceptedScreen {...props} />
  }
}

export default InvitationAcceptedScreenContainer
